import { render } from "./ListeFrequence.vue?vue&type=template&id=04d1330a"
import script from "./ListeFrequence.vue?vue&type=script&lang=js"
export * from "./ListeFrequence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__